<table
  class="mat-elevation-z8"
  mat-table
  multiTemplateDataRows
  [class.no-results]="showNoResults"
  [dataSource]="contacts"
>
  <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay; let i = index">
    <div *ngIf="column == 'status'">
      <th mat-header-cell *matHeaderCellDef>
        Status
        
        <ng-template #statusInfoTooltip>
          <span class="green">Complete</span> Customer has received all messages queued to be sent<br />
          <span class="blue">Active</span> Campaign is in progress, reminder messages remain to be sent<br />
          <span class="red">In Queue</span> Campaign has not started (due to sending hours or other Campaign settings)<br />
        </ng-template>

        <button type="button" class="btn btn-borderless p-0 info-btn"
          [ngbTooltip]="statusInfoTooltip"
        >
          <icon-info></icon-info>
        </button>
      </th>

      <td mat-cell *matCellDef="let element"
          style="min-width: 135px; text-overflow: clip"
      >
        <label class="badge badge-short" [ngClass]="contactStateBadgeColor(element[column])">
          {{contactStateBadgeLabel(element[column])}}
        </label>
      </td>
    </div>

    <div *ngIf="column == 'name'">
      <th mat-header-cell *matHeaderCellDef>Name</th>

      <td
        mat-cell
        *matCellDef="let element"
        [style.min-width]="'min-content'"
      >
        {{ element.name || "" }} {{ element.lastName || "" }}
      </td>
    </div>

    <div *ngIf="column != 'actions' && column != 'status' && column != 'name'">
      <th mat-header-cell *matHeaderCellDef>{{columnsLabels[i]}}</th>

      <td
        mat-cell
        *matCellDef="let element"
        class="text-truncate"
        [class.email-cell]="column === 'email'"
        [style.min-width]="column === 'created' || column === 'lastContact' || column === 'phoneNumber' || column == 'campaignNames' ? (column == 'campaignNames' ? '300px' : '125px') : 'min-content'"
        [style.max-width]="column === 'campaignNames' ? '1px' : 'auto'"
      >
        <div class="text-truncate" ngbTooltip="{{ column === 'email' ? element[column] : ''}}">
          {{(column == 'lastContact' || column == 'created') ? (element[column]?(element[column] | date:'short'):'') : element[column]}}
        </div>
      </td>
    </div>

    <div *ngIf="column == 'actions'">
      <th class="actions_box" mat-header-cell *matHeaderCellDef>{{columnsLabels[i]}}</th>

      <td class="actions-cell cursor-default" mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
        <div class="actions-column">
          <button 
            *ngxPermissionsOnly="['editLocationContact', 'editBusinessContact']"
            class="btn btn-borderless p-0"
            ngbTooltip="Edit"
            (click)="$event.stopPropagation(); onEdit.emit(element)"
          >
            <icon-edit></icon-edit>
          </button>

          <button
            *ngxPermissionsOnly="['archiveDeleteLocationContact', 'archiveDeleteBusinessContact']"
            class="btn btn-borderless p-0"
            ngbTooltip="Delete"
            (click)="deleteContact($event, element)"
          >
            <icon-delete></icon-delete>
          </button>
        </div>
      </td>
    </div>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <contact-history
          [contactHistory]="contactHistory"
          [contactId]="element.id"
          [created]="element.created">
        </contact-history>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>

  <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="example-element-row"
      [class.cant-view-history]="!(permissions.viewContactHistory || permissions.viewBusinessContactHistory)"
      [class.example-expanded-row]="expandedElement === element"
      (click)="didClickContact($event, element)">
  </tr>

  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>

<no-results *ngIf="showNoResults" />
